import type {IAnalytics} from '@sail/observability';

const dismountCounts: Record<string, number> = {};

const DISMOUNT_WARNING_THRESHOLD = 100;

let hasEmittedAnalytics = false;

export function warnIfComponentMountedAndDismountedRepeatedly(
  component: string,
  analytics?: IAnalytics,
): void {
  dismountCounts[component] = (dismountCounts[component] ?? 0) + 1;

  if (dismountCounts[component] > DISMOUNT_WARNING_THRESHOLD) {
    // eslint-disable-next-line no-console
    console.warn(
      `We've detected you mounted and unmounted the component '${component}' more than ${DISMOUNT_WARNING_THRESHOLD} times in this session. This likely indicates there is an unintentional render loop. See our performance best practices: https://docs.stripe.com/connect/get-started-connect-embedded-components?platform=web#performance-best-practices.`,
    );

    if (analytics && !hasEmittedAnalytics) {
      hasEmittedAnalytics = true;
      analytics.track(
        'submerchant_surfaces_repeated_component_mount_warning_emitted',
        {
          component,
        },
      );
    }
  }
}

// Exported for testing purposes
export function resetDismountCounts(): void {
  Object.keys(dismountCounts).forEach((key) => {
    delete dismountCounts[key];
  });
  hasEmittedAnalytics = false;
}
